<div class="form-element subtitle-section my-15">
  <p>{{ referenceDataLabels.CurrentPropertyId | localizeLabel }}</p>
</div>

<boi-validation-error
  [propertyNames]="['Applicant_' + applicantIndex + '.ResidentialMortgageBalanceAndMonthlyPayment']"
></boi-validation-error>

<ng-container *ngIf="applicant.canHoldMortgageOnSponsorProperty()">
  <!-- 41.12 -->
  <boi-form-radio-button
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.HoldMortgageOnSponsorProperty"
    [(value)]="applicant.HoldMortgageOnSponsorPropertyCode"
    [optionList]="referenceDataOptionLists.AnswerType"
    [propertyNames]="['Applicant_' + applicantIndex + '.HoldMortgageOnSponsorPropertyCode']"
  >
  </boi-form-radio-button>
</ng-container>
<ng-container *ngIf="isLoanGroupTypeBtlAffordability()">
  <!-- 55.1a -->
  <boi-form-radio-button
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.DoYouHaveAMortgageOnThisProperId"
    [(value)]="applicant.HoldMortgageCode"
    [optionList]="referenceDataOptionLists.AnswerType"
    [propertyNames]="['Applicant_' + applicantIndex + '.HoldMortgageCode']"
  >
  </boi-form-radio-button>
</ng-container>
<ng-container *ngIf="applicant.isHoldingMortgageOnSponsorProperty() || isHoldingMortgageOnBtlAffordability()">
  <!-- 41.12b -->
  <boi-form-numeric-input
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.MonthlyMortgageOnSponsorProperty"
    [(value)]="applicant.MonthlyMortgageOnSponsorProperty"
    [isCurrency]="true"
    [propertyNames]="['Applicant_' + applicantIndex + '.MonthlyMortgageOnSponsorProperty']"
    [fieldMaxLength]="8"
  >
  </boi-form-numeric-input>
  <!-- 41.13 -->
  <boi-form-numeric-input
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.OutstandingBalanceOnSponsorProperty"
    [(value)]="applicant.OutstandingBalanceOnSponsorProperty"
    [isCurrency]="true"
    [propertyNames]="['Applicant_' + applicantIndex + '.OutstandingBalanceOnSponsorProperty']"
    [fieldMaxLength]="8"
  >
  </boi-form-numeric-input>
</ng-container>

<ng-container *ngIf="applicant.isHoldingMortgageOnSponsorProperty()">
  <!-- 41.14 -->
  <boi-form-numeric-input
    class="years-left"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.MortgageYearsRemainingOnSponsorProperty"
    [(value)]="applicant.MortgageYearsRemainingOnSponsorProperty"
    [propertyNames]="['Applicant_' + applicantIndex + '.MortgageYearsRemainingOnSponsorProperty']"
    [fieldMaxLength]="2"
  >
  </boi-form-numeric-input>
  <!-- 41.15 -->
  <boi-form-option-list
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.RepaymentStrategyOnSponsorProperty"
    [(value)]="applicant.RepaymentStrategyOnSponsorPropertyCode"
    [optionList]="referenceDataOptionLists.SponsorRepaymentType"
    [propertyNames]="['Applicant_' + applicantIndex + '.RepaymentStrategyOnSponsorPropertyCode']"
  >
  </boi-form-option-list>

  <ng-container
    *ngIf="
      applicant.RepaymentStrategyOnSponsorPropertyCode === referenceDataOptionLists.SponsorRepaymentTypeInterestOnly
    "
  >
    <!-- 41.16 -->
    <boi-form-numeric-input
      class="monthly-amount"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.MonthlyCostOnSponsorProperty"
      [(value)]="applicant.MonthlyCostOnSponsorProperty"
      [isCurrency]="true"
      [propertyNames]="['Applicant_' + applicantIndex + '.MonthlyCostOnSponsorProperty']"
      [fieldMaxLength]="4"
    >
    </boi-form-numeric-input>
  </ng-container>
</ng-container>

<ng-container *ngIf="isLoanGroupTypeBtlAffordability()">
  <!-- 55.3 -->
  <boi-form-radio-button
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.RemortgageCurrentResidentialPropertyCode"
    [(value)]="applicant.RemortgageCurrentResidentialPropertyCode"
    [optionList]="referenceDataOptionLists.AnswerType"
    [propertyNames]="['Applicant_' + applicantIndex + '.RemortgageCurrentResidentialPropertyCode']"
  >
  </boi-form-radio-button>
  <ng-container *ngIf="isRemortgageCurrentResidentialProperty()">
    <!-- 41.19 -->
    <boi-form-numeric-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.NewMonthlyMortgagePaymentPrediction"
      [(value)]="applicant.NewMonthlyMortgagePaymentPrediction"
      [isCurrency]="true"
      [propertyNames]="['Applicant_' + applicantIndex + '.NewMonthlyMortgagePaymentPrediction']"
      [fieldMaxLength]="8"
    >
    </boi-form-numeric-input>
    <!-- 41.20 -->
    <boi-form-numeric-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.NewOutstandingBalancePrediction"
      [(value)]="applicant.NewOutstandingBalancePrediction"
      [isCurrency]="true"
      [propertyNames]="['Applicant_' + applicantIndex + '.NewOutstandingBalancePrediction']"
      [fieldMaxLength]="8"
    >
    </boi-form-numeric-input>
  </ng-container>
</ng-container>
<ng-container *ngIf="canHoldAnotherMortgage()">
  <!-- 55.1 & 55.2 -->
  <boi-form-radio-button
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="
      isApplicantRemortgaging()
        ? referenceDataLabels.MortgageOnThisPropertyWhileRemortgaging
        : referenceDataLabels.DoYouHaveAMortgageOnThisProperId
    "
    [(value)]="applicant.HoldMortgageCode"
    [optionList]="referenceDataOptionLists.AnswerType"
    [propertyNames]="['Applicant_' + applicantIndex + '.HoldMortgageCode']"
  >
  </boi-form-radio-button>
</ng-container>
<ng-container *ngIf="isBtlRemortgaging()">
  <!-- 120 -->
  <boi-form-radio-button
    [isFieldDisabled]="true"
    [labelName]="referenceDataLabels.HoldMortgageOnBTL"
    [(value)]="applicant.HoldMortgageBTLCode"
    [optionList]="referenceDataOptionLists.AnswerType"
    [propertyNames]="['Applicant_' + applicantIndex + '.HoldMortgageBTLCode']"
  >
  </boi-form-radio-button>
</ng-container>
<ng-container *ngIf="shouldShowMortgageOwed()">
  <!-- 121a & 121b -->
  <boi-form-numeric-input
    [isFieldDisabled]="
      mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly || isBtlRemortgaging()
    "
    [labelName]="referenceDataLabels.HowMuchDoYouCurrentlyOweOnThePId"
    [(value)]="applicant.ResidentialMortgageOwed"
    [isCurrency]="true"
    [propertyNames]="['Applicant_' + applicantIndex + '.ResidentialMortgageOwed']"
    [fieldMaxLength]="8"
  >
  </boi-form-numeric-input>
</ng-container>
<ng-container *ngIf="shouldDisplayAmountOwedOnRemortgagedProperty()">
  <!-- 121.02 -->
  <boi-form-numeric-input
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.AmountOwedOnRemortgagedProperty"
    [forceRequired]="true"
    [(value)]="applicant.AmountOwedOnRemortgagedProperty"
    [isCurrency]="true"
    [propertyNames]="['Applicant_' + applicantIndex + '.AmountOwedOnRemortgagedProperty']"
    [fieldMaxLength]="8"
  >
  </boi-form-numeric-input>
</ng-container>
<ng-container *ngIf="shouldDisplayRemainderFundingDetailsForApplicant()">
  <!-- 121.03 -->
  <boi-form-textarea
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.MortgageRemainderFundingDetailsForApplicant"
    [(value)]="applicant.MortgageRemainderFundingDetails"
    [propertyNames]="['Applicant_' + applicantIndex + '.MortgageRemainderFundingDetails']"
    [fieldMaxLength]="1500"
  >
  </boi-form-textarea>
</ng-container>
<ng-container *ngIf="mortgageApplication.isBuyToLet && applicant.isRemortgaging()">
  <boi-form-radio-button
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.AreYouConvertingPropToBtl"
    [(value)]="applicant.ConvertPropertyToBtlCode"
    [optionList]="referenceDataOptionLists.AnswerType"
    [propertyNames]="['Applicant_' + applicantIndex + '.ConvertPropertyToBtlCode']"
  >
  </boi-form-radio-button>
  <boi-form-radio-button
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.HadIntentionToRentToStrangersCode"
    [(value)]="applicant.HadIntentionToRentToStrangersCode"
    [optionList]="referenceDataOptionLists.AnswerType"
    [propertyNames]="['Applicant_' + applicantIndex + '.HadIntentionToRentToStrangersCode']"
  >
  </boi-form-radio-button>
  <boi-form-radio-button
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.IsPropertyInheritedCode"
    [(value)]="applicant.IsPropertyInheritedCode"
    [optionList]="referenceDataOptionLists.AnswerType"
    [propertyNames]="['Applicant_' + applicantIndex + '.IsPropertyInheritedCode']"
  >
  </boi-form-radio-button>
  <boi-form-radio-button
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.HaveYouLivedOnThisPropertyCode"
    [(value)]="applicant.HaveYouLivedOnThisPropertyCode"
    [optionList]="referenceDataOptionLists.AnswerType"
    [propertyNames]="['Applicant_' + applicantIndex + '.HaveYouLivedOnThisPropertyCode']"
  >
  </boi-form-radio-button>
</ng-container>

<ng-container *ngIf="hasMortgagePayment()">
  <!-- 121.1 -->
  <boi-form-numeric-input
    [isFieldDisabled]="
      mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly || isBtlRemortgaging()
    "
    [labelName]="referenceDataLabels.MonthlyMortgageAmount"
    [(value)]="applicant.MonthlyMortgageAmount"
    [isCurrency]="true"
    [propertyNames]="['Applicant_' + applicantIndex + '.MonthlyMortgageAmount']"
    [fieldMaxLength]="8"
  >
  </boi-form-numeric-input>
</ng-container>

<ng-container *ngIf="shouldShowLenderQuestions()">
  <boi-form-text-input
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.WhoIsYourLenderId"
    [(value)]="applicant.WhoLender"
    [propertyNames]="['Applicant_' + applicantIndex + '.WhoLender']"
    [fieldMaxLength]="30"
  >
  </boi-form-text-input>
  <!-- applicant ERC Questions -->
  <ng-container *ngIf="mortgageApplication.IsFactFind">
    <!--HasMortgageAnErc-->
    <boi-form-radio-button
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.HasMortgageAnERC"
      [(value)]="applicant.HasMortgageAnERC"
      [optionList]="referenceDataOptionLists.AnswerType"
      [propertyNames]="['Applicant_' + applicantIndex + '.HasMortgageAnERC']"
    >
    </boi-form-radio-button>
    <ng-container *ngIf="applicant.HasMortgageAnERC === referenceDataOptionLists.AnswerTypeYes">
      <!--ERCAmount-->
      <boi-form-text-input
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
        [labelName]="referenceDataLabels.ERCAmount"
        [(value)]="applicant.ERCAmount"
        [propertyNames]="['Applicant_' + applicantIndex + '.ERCAmount']"
        [fieldMaxLength]="8"
      >
      </boi-form-text-input>
      <!--ERCEndDate-->
      <boi-form-date
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
        [labelName]="referenceDataLabels.ERCEndDate"
        [(value)]="applicant.ERCEndDate"
        [propertyNames]="['Applicant_' + applicantIndex + '.ERCEndDate']"
      >
      </boi-form-date>
    </ng-container>
    <!--IsPortableMortgage-->
    <boi-form-radio-button
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.IsPortableMortgage"
      [(value)]="applicant.IsPortableMortgage"
      [optionList]="referenceDataOptionLists.AnswerType"
      [propertyNames]="['Applicant_' + applicantIndex + '.IsPortableMortgage']"
    >
    </boi-form-radio-button>
  </ng-container>
  <!-- TODO add dash section here? -->
  <ng-container *ngIf="!mortgageApplication.IsFactFind">
    <boi-form-address
      [(address)]="applicant.LenderAddress"
      [addressLine1Required]="true"
      [propertyName]="['Applicant_' + applicantIndex + '.LenderAddress']"
      [labelName]="referenceDataLabels.LenderAddressId"
      [mortgageApplication]="mortgageApplication"
      [showCountryCode]="true"
      [hideFindAddress]="false"
      [isFindAddressButtonDisabled]="mortgageApplication?.IsApplicationReadOnly"
    >
    </boi-form-address>
    <boi-form-text-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.MortgageAccountNumberId"
      [(value)]="applicant.MortgageAccountNumber"
      [propertyNames]="['Applicant_' + applicantIndex + '.MortgageAccountNumber']"
      [fieldMaxLength]="20"
    >
    </boi-form-text-input>
    <boi-form-term-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.HowLongHaveYouBeenWithThisLendId"
      [(years)]="applicant.HowLongWithLenderYears"
      [(months)]="applicant.HowLongWithLenderMonths"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.HowLongWithLenderYears',
        'Applicant_' + applicantIndex + '.HowLongWithLenderMonths'
      ]"
    >
    </boi-form-term-input>
  </ng-container>
</ng-container>
<ng-container
  *ngIf="
    mortgageApplication.isResidential &&
    mortgageApplication.IsFullApp &&
    applicant.cannotHoldMortgageOnSponsorProperty() &&
    canSellProperty()
  "
>
  <boi-form-radio-button
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.AreYouSellingYourCurrentResideId"
    [(value)]="applicant.SellingCurrentResidentialPropertyCode"
    [optionList]="referenceDataOptionLists.AnswerType"
    [propertyNames]="['Applicant_' + applicantIndex + '.SellingCurrentResidentialPropertyCode']"
  >
  </boi-form-radio-button>
  <ng-container *ngIf="applicant.SellingCurrentResidentialPropertyCode === referenceDataOptionLists.AnswerTypeYes">
    <boi-form-numeric-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.PropertySellingPriceId"
      [(value)]="applicant.PropertySellingPrice"
      [isCurrency]="true"
      [propertyNames]="['Applicant_' + applicantIndex + '.PropertySellingPrice']"
      [fieldMaxLength]="7"
    >
    </boi-form-numeric-input>
  </ng-container>
</ng-container>
<ng-container
  *ngIf="
    mortgageApplication.isResidential && canSellProperty() && canHoldAnotherMortgage() && applicant.holdsMortgage()
  "
>
  <!-- 122 -->
  <boi-form-radio-button
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.WillMortgageBeRedeemed"
    [(value)]="applicant.RedeemingResidentialMortgageCode"
    [optionList]="referenceDataOptionLists.AnswerType"
    [propertyNames]="['Applicant_' + applicantIndex + '.RedeemingResidentialMortgageCode']"
  >
  </boi-form-radio-button>
</ng-container>
<ng-container *ngIf="shouldDisplayFutureCorrespondenceAddress()">
  <boi-form-address
    [(address)]="applicant.FutureCorrespondingAddress"
    [addressLine1Required]="true"
    [propertyName]="['Applicant_' + applicantIndex + '.FutureCorrespondingAddress']"
    [labelName]="referenceDataLabels.WhereShouldFutureCorrespondencId"
    [mortgageApplication]="mortgageApplication"
    [showCountryCode]="true"
    [hideFindAddress]="false"
    [isFindAddressButtonDisabled]="mortgageApplication?.IsApplicationReadOnly"
  >
  </boi-form-address>
</ng-container>
<!-- applicantYourCurrentPropertiesPurchaseNoMortgage -->
<ng-container
  *ngIf="
    mortgageApplication.isResidential &&
    mortgageApplication.IsFullApp &&
    applicant.HoldMortgageCode === referenceDataOptionLists.AnswerTypeNo
  "
>
  <boi-form-radio-button
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.HeldResidentialMortgage"
    [(value)]="applicant.HoldMortgageWithin12LastMonthCode"
    [optionList]="referenceDataOptionLists.AnswerType"
    [propertyNames]="['Applicant_' + applicantIndex + '.HoldMortgageWithin12LastMonthCode']"
  >
  </boi-form-radio-button>
  <ng-container *ngIf="applicant.HoldMortgageWithin12LastMonthCode === referenceDataOptionLists.AnswerTypeYes">
    <boi-form-text-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.WhoWasTheLender"
      [(value)]="applicant.WhoWasLender"
      [propertyNames]="['Applicant_' + applicantIndex + '.WhoWasLender']"
      [fieldMaxLength]="30"
    >
    </boi-form-text-input>
    <boi-form-numeric-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.AproxRedemOutstandingBalance"
      [(value)]="applicant.ApproximateOutstandingBalance"
      [isCurrency]="true"
      [propertyNames]="['Applicant_' + applicantIndex + '.ApproximateOutstandingBalance']"
      [fieldMaxLength]="8"
    >
    </boi-form-numeric-input>
    <boi-form-numeric-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.HowManyYearsWithLender"
      [(value)]="applicant.HowLongWithLenderYears"
      [propertyNames]="['Applicant_' + applicantIndex + '.HowLongWithLenderYears']"
      [fieldMaxLength]="2"
    >
    </boi-form-numeric-input>
  </ng-container>
</ng-container>
<ng-container *ngIf="mortgageApplication.isResidential">
  <ng-container *ngIf="canHoldAnotherNonBtl()">
    <!-- 127 -->
    <boi-form-radio-button
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.WillYouHoldAnyOtherNonBuyToLetId"
      [(value)]="applicant.HoldAnyOtherNonBtlCode"
      [optionList]="referenceDataOptionLists.AnswerType"
      [propertyNames]="['Applicant_' + applicantIndex + '.HoldAnyOtherNonBtlCode']"
      [contextualHelpName]="referenceDataContextualHelps.AppHoldAnyOtherNonBtl"
    >
    </boi-form-radio-button>
  </ng-container>
  <ng-container *ngIf="holdsAnotherNonBtl()">
    <!-- 128 -->
    <boi-form-numeric-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.HowManyWillYouHoldId"
      [(value)]="applicant.HowManyOtherNonBtl"
      [propertyNames]="['Applicant_' + applicantIndex + '.HowManyOtherNonBtl']"
      [fieldMaxLength]="2"
    >
    </boi-form-numeric-input>
    <ng-container *ngIf="mortgageApplication.IsFactFind">
      <boi-form-numeric-input
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
        [labelName]="referenceDataLabels.ApproximateOutstandingBalance"
        [(value)]="applicant.OutstandingBalanceAmount"
        [isCurrency]="true"
        [propertyNames]="['Applicant_' + applicantIndex + '.OutstandingBalanceAmount']"
        [fieldMaxLength]="8"
        [contextualHelpName]="referenceDataContextualHelps.OutstandingBalanceAmount"
      >
      </boi-form-numeric-input>
      <boi-form-numeric-input
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
        [labelName]="referenceDataLabels.TotalMonthlyPayment"
        [(value)]="applicant.TotalMonthlyPayment"
        [isCurrency]="true"
        [propertyNames]="['Applicant_' + applicantIndex + '.TotalMonthlyPayment']"
        [fieldMaxLength]="8"
      >
      </boi-form-numeric-input>
    </ng-container>
    <!-- 129 -->
    <boi-form-textarea
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.PleaseProvideDetailsOfBalanceOId"
      [(value)]="applicant.BalanceOutstandingAndReasonForMortgageDetails"
      [propertyNames]="['Applicant_' + applicantIndex + '.BalanceOutstandingAndReasonForMortgageDetails']"
      [fieldMaxLength]="1500"
    >
    </boi-form-textarea>
  </ng-container>
  <!-- 129.1 -->
  <boi-form-radio-button
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.WillYouHoldAnyBuyToLetMortgageId"
    [(value)]="applicant.HoldAnyBtlCode"
    [optionList]="referenceDataOptionLists.AnswerType"
    [propertyNames]="['Applicant_' + applicantIndex + '.HoldAnyBtlCode']"
  >
  </boi-form-radio-button>
  <ng-container *ngIf="applicant.HoldAnyBtlCode === referenceDataOptionLists.AnswerTypeYes">
    <!-- 129.2 -->
    <boi-form-numeric-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.HowManyBtlMortgages"
      [(value)]="applicant.HowManyBtl"
      [propertyNames]="['Applicant_' + applicantIndex + '.HowManyBtl']"
      [fieldMaxLength]="2"
      [contextualHelpName]="
        mortgageApplication.ApplicationCase.IsAdvisedCase
          ? referenceDataContextualHelps.AdvisedAppHowManyBtl
          : referenceDataContextualHelps.AppHowManyBtl
      "
    >
    </boi-form-numeric-input>
  </ng-container>

  <!-- 41.17 & 41.18 -->
  <ng-container *ngIf="applicant.canHoldMortgageOnSponsorProperty()">
    <boi-form-numeric-input
      class="dependents"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.NumberOfSponsorDependents"
      [(value)]="applicant.NumberOfSponsorDependants"
      [propertyNames]="['Applicant_' + applicantIndex + '.NumberOfSponsorDependants']"
      [fieldMaxLength]="2"
      (valueChange)="initializeSponsorDependants()"
    >
    </boi-form-numeric-input>

    <ng-container *ngIf="applicant.NumberOfSponsorDependants > 0">
      <ng-container
        *ngFor="
          let applicantSponsorDependant of applicant.ApplicantSponsorDependants;
          index as applicantSponsorDependantIndex
        "
      >
        <boi-form-numeric-input
          [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
          [labelName]="referenceDataLabels.AgeOfSponsorFinancialDependant"
          [labelIndex]="applicantSponsorDependantIndex + 1"
          [(value)]="applicantSponsorDependant.Age"
          [propertyNames]="[
            'Applicant_' + applicantIndex + '.ApplicantSponsorDependant_' + applicantSponsorDependantIndex + '.Age'
          ]"
          [fieldMaxLength]="3"
        >
        </boi-form-numeric-input>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<div
  *ngIf="
    mortgageApplication.Applicants.length < 4 &&
    !(mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly)
  "
  class="vo-display-none add-applicant-container"
>
  <div class="form-element add-applicant d-flex">
    <div class="form-label">{{ referenceDataLabels.AddAnotherApplicant | localizeLabel }}</div>
    <div class="form-input-container ml-30">
      <button class="primary-button vo-secondary-button-1" (click)="addApplicant.emit()">
        + {{ referenceDataLabels.ButtonAddAnotherApplicant | localizeLabel }}
      </button>
    </div>
  </div>
</div>

<div
  *ngIf="
    mortgageApplication.Applicants.length < 4 &&
    !(mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly)
  "
  class="bo-display-none d-flex flex-row-reverse flex-md-row mt-15"
>
  <button class="vo-secondary-button-1 vo-add-applicant-button full-width-md-button" (click)="addApplicant.emit()">
    + {{ referenceDataLabels.AddAnotherApplicant | localizeLabel }}
  </button>
</div>
